import React, { Fragment, useState } from 'react';
import { useTranslation } from 'next-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { selectGiftCardValuesData } from '@selectors/giftCards';
import { addGiftCard } from '@actions/giftCards';

import { numberToSup } from '@utils/formatNumber';

import Button, { BUTTON_VARIANTS } from '@common/components/Button';
import { RadioButton } from '@common/components/forms';
import { SIZES } from '@common/components/forms/RadioButton/constants';

import { GiftCardValuesWrapper } from './AddCard.styled';

const AddCard = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const cardValues = useSelector(selectGiftCardValuesData);

  const [selectedValue, setSelectedValue] = useState(null);

  const handleSelectGiftCardValue = ({ target }) => {
    setSelectedValue(parseInt(target.value, 10));
  };
  const handleAddGiftCardToOrder = () => {
    dispatch(addGiftCard(selectedValue));
  };

  return (
    <Fragment>
      <GiftCardValuesWrapper>
        {cardValues.map(value => (
          <RadioButton
            key={value}
            name={`giftCard-${value}`}
            onChange={handleSelectGiftCardValue}
            checked={selectedValue === value}
            value={value}
            text={t('giftCards.order.cards.cardValue', 'CHF {{value}}', {
              value: numberToSup(value),
            })}
            size={SIZES.LARGE}
          />
        ))}
      </GiftCardValuesWrapper>

      <Button
        type="button"
        variant={BUTTON_VARIANTS.LEVEL_1_GREEN}
        disabled={!selectedValue}
        onClick={handleAddGiftCardToOrder}
      >
        {t('giftCards.order.cards.button', 'Auswahl hinzufügen')}
      </Button>
    </Fragment>
  );
};

export default AddCard;
